import { useEffect } from 'react';
import { State, useStore } from 'store';

import fetchRuns from 'store/fetchRuns';
import getCurrentProjectState from 'store/getCurrentProjectState';

import IAsync from 'types/IAsync';
import IPaginatedResponse from 'types/IPaginatedResponse';
import IRunEntry from 'types/IRunEntry';

export default function useAutofetchedRunsAsync({
  page,
  pageSize,
  search,
}: {
  page?: number;
  pageSize?: number;
  search?: string;
} = {}): IAsync<IPaginatedResponse<IRunEntry>> {
  const runsAsync = useStore(
    (state: State) => getCurrentProjectState(state).runsAsync,
  );

  useEffect(() => {
    fetchRuns({ page, pageSize, search });
  }, [page, pageSize, search]);

  return runsAsync;
}
